export default __webpack_public_path__ + "static/media/GLVR.0dae9de4.webp";